import React, { useEffect, useState } from 'react'

import { numberToString } from 'shared/utils'

import classes from './Calculator.module.scss'
import { calculatorValues } from './calculatorConst'
import { DistributionCalculatorInput } from './Input'

export const DistributionCalculator = (): JSX.Element => {
  const [value, setValue] = useState(250)
  const [sum, setSum] = useState(calculate())
  useEffect(() => {
    const newValue = calculate()
    setSum(newValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  function calculate() {
    return numberToString(calculatorValues.get(value) ?? 0)
  }

  return (
    <>
      <div className={classes.sum_container}>
        <div className={classes.sum_count}>{sum}</div>
        <span className="color-secondary mt-2">Доход за год (в рублях)*</span>
      </div>
      <div className={classes.range_container}>
        <DistributionCalculatorInput onChange={setValue} value={value} />
      </div>
      <div className={classes.range_descr}>Привлеченных клиентов в месяц</div>
      <div className={classes.note}>
        *Пример расчёта дохода носит исключительно информационный{'\n'}характер
        и не является публичной офертой
      </div>
    </>
  )
}
